export const REF_LINKS = {
  V_EDITOR_HEADER_BUTTON: 'v-editor-header-button',
  V_EDITOR_AI_IMAGE_GENERATE: 'v-editor-ai-image-generate',
  V_EDITOR_AI_VIDEO_GENERATE: 'v-editor-ai-video-generate',
  V_EDITOR_AI_IMAGE_REFILL: 'v-editor-ai-image-refill',
  V_EDITOR_AI_VIDEO_REFILL: 'v-editor-ai-video-refill',
  V_EDITOR_TTS_GENERATE: 'v-editor-tts-generate',
  PREMIUM_AI_MODELS: 'premium-ai-models-v-editor'
}
